export default (url: any) => {
  if (url && url.trim()) {
    try {
      const parsedUrl = new URL(url)
      if (/mailto/.test(parsedUrl.protocol)) {
        window.location.href = url
      } else {
        window.open(url)
      }
    } catch {
      // Nom nom nom
    }
  }
}
